import Immutable from 'immutable';
import createReducers from '../utils/createreducer';

import {
    RACE_GET_ALL_REQUEST, RACE_GET_ALL_SUCCESS, RACE_GET_ALL_FAILURE,
    RACE_GET_DETAILS_REQUEST, RACE_GET_DETAILS_SUCCESS, RACE_GET_DETAILS_FAILURE,
    RACE_CREATE_REQUEST, RACE_CREATE_SUCCESS, RACE_CREATE_FAILURE,
    RACE_UPDATE_REQUEST, RACE_UPDATE_SUCCESS, RACE_UPDATE_FAILURE,
    RACE_DELETE_REQUEST, RACE_DELETE_SUCCESS, RACE_DELETE_FAILURE,
    RACE_GET_PIGEONS_REQUEST, RACE_GET_PIGEONS_SUCCESS, RACE_GET_PIGEONS_FAILURE,
    RACE_CREATE_PIGEON_REQUEST, RACE_CREATE_PIGEON_SUCCESS, RACE_CREATE_PIGEON_FAILURE,
    RACE_UPDATE_PIGEON_REQUEST, RACE_UPDATE_PIGEON_SUCCESS, RACE_UPDATE_PIGEON_FAILURE,
    RACE_DELETE_PIGEON_REQUEST, RACE_DELETE_PIGEON_SUCCESS, RACE_DELETE_PIGEON_FAILURE,
    RACE_CREATE_WATCH_REQUEST, RACE_CREATE_WATCH_SUCCESS, RACE_CREATE_WATCH_FAILURE,
    RACE_UPDATE_WATCH_REQUEST, RACE_UPDATE_WATCH_SUCCESS, RACE_UPDATE_WATCH_FAILURE,
    RACE_DELETE_WATCH_REQUEST, RACE_DELETE_WATCH_SUCCESS, RACE_DELETE_WATCH_FAILURE,
    RACE_ADD_MEMBER_GAMES_REQUEST, RACE_ADD_MEMBER_GAMES_SUCCESS, RACE_ADD_MEMBER_GAMES_FAILURE,
    RACE_REMOVE_MEMBER_GAMES_REQUEST, RACE_REMOVE_MEMBER_GAMES_SUCCESS, RACE_REMOVE_MEMBER_GAMES_FAILURE,
    RACE_ADD_DECAYS_REQUEST, RACE_ADD_DECAYS_SUCCESS, RACE_ADD_DECAYS_FAILURE,
    RACE_REMOVE_DECAYS_REQUEST, RACE_REMOVE_DECAYS_SUCCESS, RACE_REMOVE_DECAYS_FAILURE,
    RACE_GET_PRICES_REQUEST, RACE_GET_PRICES_SUCCESS, RACE_GET_PRICES_FAILURE,
    RACE_CREATE_PRICE_REQUEST, RACE_CREATE_PRICE_SUCCESS, RACE_CREATE_PRICE_FAILURE,
    RACE_UPDATE_PRICE_REQUEST, RACE_UPDATE_PRICE_SUCCESS, RACE_UPDATE_PRICE_FAILURE,
    RACE_DELETE_PRICE_REQUEST, RACE_DELETE_PRICE_SUCCESS, RACE_DELETE_PRICE_FAILURE,
    RACE_UPDATE_PRICE_ADDITIONS_REQUEST, RACE_UPDATE_PRICE_ADDITIONS_SUCCESS, RACE_UPDATE_PRICE_ADDITIONS_FAILURE,
    RACE_RESET_PRICES_REQUEST, RACE_RESET_PRICES_SUCCESS, RACE_RESET_PRICES_FAILURE,
    RACE_CALC_PRICES_REQUEST, RACE_CALC_PRICES_SUCCESS, RACE_CALC_PRICES_FAILURE,
    RACE_GET_BASICS_REQUEST, RACE_GET_BASICS_SUCCESS, RACE_GET_BASICS_FAILURE,
    RACE_START_DEVICE_IMPORT_REQUEST, RACE_START_DEVICE_IMPORT_SUCCESS, RACE_START_DEVICE_IMPORT_FAILURE,
    RACE_UPDATE_DEVICE_IMPORT_REQUEST, RACE_UPDATE_DEVICE_IMPORT_SUCCESS, RACE_UPDATE_DEVICE_IMPORT_FAILURE,
    RACE_CHECK_DEVICE_IMPORT_REQUEST, RACE_CHECK_DEVICE_IMPORT_SUCCESS, RACE_CHECK_DEVICE_IMPORT_FAILURE,

    ADMIN_START_SEASON_REQUEST, ADMIN_START_SEASON_SUCCESS, ADMIN_START_SEASON_FAILURE,
    ADMIN_SELECT_USER_ROLE_REQUEST, ADMIN_SELECT_USER_ROLE_SUCCESS, ADMIN_SELECT_USER_ROLE_FAILURE,
    ADMIN_SELECT_DATABASE_REQUEST, ADMIN_SELECT_DATABASE_SUCCESS, ADMIN_SELECT_DATABASE_FAILURE,
    ADMIN_CREATE_DEPOSIT_SUCCESS,
    ADMIN_UPDATE_DEPOSIT_SUCCESS,
    ADMIN_CREATE_MARKING_SUCCESS,
    ADMIN_UPDATE_MARKING_SUCCESS,
} from '../constants/actionconstants';
import initialStoreState from '../store/initialstorestate';

import {mergeFunction} from "../../../common/src/util/lib";

const initialState = initialStoreState.race;

export default createReducers(initialState, {
    [RACE_GET_ALL_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isRacesRead : true
        });
    },
    [RACE_GET_ALL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            races : state.races.mergeWith(mergeFunction, Immutable.Map(payload.map(race => [race.Nr, Object.assign({}, race)]))),
            isRacesRead: true
        });
    },
    [RACE_GET_DETAILS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            races : state.races.mergeWith(mergeFunction, Immutable.Map([[payload.race.Nr, Object.assign({}, payload.race)]])),
        });
    },
    [RACE_CREATE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            races: state.races.merge(Immutable.Map([[payload.race.Nr, Object.assign({}, payload.race)]])),
        })
    },
    [RACE_UPDATE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            races: state.races.merge(Immutable.Map([[payload.race.Nr, Object.assign({}, payload.race)]])),
        })
    },
    [RACE_DELETE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            races: state.races.delete(payload),
        })
    },
    [RACE_GET_PIGEONS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, {
                night: payload.racePigeons.night,
                pigeonholes: Immutable.Map(payload.racePigeons.pigeonholes.map(pigeonhole => [pigeonhole.Slagnr, {
                    Slagnr: pigeonhole.Slagnr,
                    Slagnavn: pigeonhole.Slagnavn,
                    Afstand: pigeonhole.Afstand,
                    Slagspil: pigeonhole.Slagspil,
                    Forfald: pigeonhole.Forfald,
                    pigeons: Immutable.Map(pigeonhole.pigeons.map(pigeon => [pigeon.Ringnummer, pigeon])),
                    activePigeons: Immutable.Map(pigeonhole.activePigeons.map(pigeon => [pigeon.Ringnummer, pigeon])),
                    watches: Immutable.Map(pigeonhole.watches.map(watch => [watch.Urnr, watch])),
                }]))
            })]])),
        })
    },
    [RACE_CREATE_PIGEON_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.merge(Immutable.Map([[payload.pigeon.Ringnummer, payload.pigeon]]))
                })]]))
            })]]))
        })
    },
    [RACE_UPDATE_PIGEON_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.delete(payload.originalRing).merge(Immutable.Map([[payload.pigeon.Ringnummer, payload.pigeon]]))
                })]]))
            })]]))
        })
    },
    [RACE_DELETE_PIGEON_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    pigeons: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).pigeons.delete(payload.ring)
                })]]))
            })]]))
        })
    },
    [RACE_CREATE_WATCH_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.merge(Immutable.Map([[payload.watch.Urnr, payload.watch]]))
                })]]))
            })]]))
        })
    },
    [RACE_UPDATE_WATCH_SUCCESS] : (state, payload) => {
        if (payload.originalPigeonhole === payload.pigeonhole) return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.delete(payload.originalWatch).merge(Immutable.Map([[payload.watch.Urnr, payload.watch]]))
                })]]))
            })]]))
        }); else return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.originalPigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.originalPigeonhole), {
                    watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.originalPigeonhole).watches.delete(payload.originalWatch)
                })], [payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.merge(Immutable.Map([[payload.watch.Urnr, payload.watch]]))
                })]]))
            })]]))
        })
    },
    [RACE_DELETE_WATCH_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.merge(Immutable.Map([[payload.pigeonhole, Object.assign({}, state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole), {
                    watches: state.racePigeons.get(payload.key).pigeonholes.get(payload.pigeonhole).watches.delete(payload.watch)
                })]]))
            })]]))
        })
    },
    [RACE_ADD_MEMBER_GAMES_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(pigeonhole => Object.assign({}, pigeonhole, {
                    Slagspil: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Slagspil : true
                }))
            })]]))
        })
    },
    [RACE_REMOVE_MEMBER_GAMES_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(pigeonhole => Object.assign({}, pigeonhole, {
                    Slagspil: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Slagspil : false
                }))
            })]]))
        })
    },
    [RACE_ADD_DECAYS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(pigeonhole => Object.assign({}, pigeonhole, {
                    Forfald: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Forfald : true
                }))
            })]]))
        })
    },
    [RACE_REMOVE_DECAYS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            racePigeons: state.racePigeons.merge(Immutable.Map([[payload.key, Object.assign({}, state.racePigeons.get(payload.key), {
                pigeonholes: state.racePigeons.get(payload.key).pigeonholes.map(pigeonhole => Object.assign({}, pigeonhole, {
                    Forfald: payload.pigeonholes.indexOf(pigeonhole.Slagnr) < 0 ? pigeonhole.Forfald : false
                }))
            })]]))
        })
    },
    [RACE_GET_PRICES_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, {
                kontant: Immutable.Map(payload.prices.kontant.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                slagspil: Immutable.Map(payload.prices.slagspil.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                espil: Immutable.Map(payload.prices.espil.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                pspil: Immutable.Map(payload.prices.pspil.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                zspil: Immutable.Map(payload.prices.zspil.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                dm: Immutable.Map(payload.prices.dm.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                slag: Immutable.Map(payload.prices.slag.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                serie: Immutable.Map(payload.prices.serie.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                derby: Immutable.Map(payload.prices.derby.map(price => [price.Sektion + '/' + price.Vaerdi, {
                    Sektion: price.Sektion,
                    Vaerdi: price.Vaerdi,
                    Antal: price.Antal,
                }])),
                kontantAdditions: Immutable.Map(payload.prices.kontantAdditions.map(price => [price.Sektionsnr, price])),
            }]]))
        })
    },
    [RACE_CREATE_PRICE_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type]: state.racePrices.get(payload.race)[payload.type].merge(Immutable.Map([[payload.price.Sektion + '/' + payload.price.Vaerdi, payload.price]]))
            })]]))
        })
    },
    [RACE_UPDATE_PRICE_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type]: state.racePrices.get(payload.race)[payload.type].delete(payload.originalSection + '/' + payload.originalValue).merge(Immutable.Map([[payload.price.Sektion + '/' + payload.price.Vaerdi, payload.price]]))
            })]]))
        })
    },
    [RACE_DELETE_PRICE_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type]: state.racePrices.get(payload.race)[payload.type].delete(payload.section + '/' + payload.value)
            })]]))
        })
    },
    [RACE_UPDATE_PRICE_ADDITIONS_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type + 'Additions']: Immutable.Map(payload.prices.map(price => [price.Sektionsnr, price]))
            })]]))
        })
    },
    [RACE_RESET_PRICES_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type]: Immutable.Map(payload.prices.map(price => [price.Sektion + '/' + price.Vaerdi, price]))
            })]]))
        })
    },
    [RACE_CALC_PRICES_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            racePrices: state.racePrices.merge(Immutable.Map([[payload.race, Object.assign({}, state.racePrices.get(payload.race), {
                [payload.type]: Immutable.Map(payload.prices.map(price => [price.Sektion + '/' + price.Vaerdi, price]))
            })]]))
        })
    },
    [RACE_GET_BASICS_SUCCESS] :  (state, payload) => {
        return Object.assign({}, state, {
            deposits: Immutable.Map(payload.deposits.map(deposit => [deposit.Sektionsnr, Object.assign({}, deposit)])),
            markings: Immutable.Map(payload.markings.map(marking => [marking.Sektionsnr, Object.assign({}, marking)])),
        })
    },

    [ADMIN_CREATE_DEPOSIT_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            deposits: new Immutable.Map(),
        });
    },
    [ADMIN_UPDATE_DEPOSIT_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            deposits: new Immutable.Map(),
        });
    },
    [ADMIN_CREATE_MARKING_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            markings: new Immutable.Map()
        });
    },
    [ADMIN_UPDATE_MARKING_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            markings: new Immutable.Map()
        });
    },

    [RACE_START_DEVICE_IMPORT_REQUEST]: (state, payload) => {
        if (payload.input.requestType === 'version') return Object.assign({}, state, {
            deviceImporterVersion: null,
            deviceComPorts: ''
        });
        else return Object.assign({}, state);
    },

    [RACE_START_DEVICE_IMPORT_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            deviceImports: state.deviceImports.merge([[payload.id, payload]])
        });
    },

    [RACE_UPDATE_DEVICE_IMPORT_SUCCESS]: (state, payload) => {
        if (payload.info === "cancelled") return Object.assign({}, state, {
            deviceImports: state.deviceImports.delete(payload.id)
        }); else return Object.assign({}, state);
    },

    [RACE_CHECK_DEVICE_IMPORT_SUCCESS]: (state, payload) => {
        if (payload.ended === null) return Object.assign({}, state);
        else if (payload.requestType === 'version') return Object.assign({}, state, {
            deviceImports: state.deviceImports.delete(payload.id),
            deviceImporterVersion: payload.info === "success" ? payload.data.split(' ')[0] : "-",
            deviceComPorts: payload.info === "success" && payload.data.includes(' ') ? ':' + payload.data.split(' ')[1].toLowerCase() + ':' : '',
        });
        else return Object.assign({}, state, {
            deviceImports: state.deviceImports.delete(payload.id)
        });
    },

    [RACE_CHECK_DEVICE_IMPORT_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            deviceImports: state.deviceImports.delete(payload.id)
        });
    },

    [ADMIN_START_SEASON_SUCCESS] : (state, {championshipNo, ringNo}) => {
        return Object.assign({}, initialStoreState.race);
    },

    [ADMIN_SELECT_USER_ROLE_SUCCESS] : (state, {championshipNo, ringNo}) => {
        return Object.assign({}, initialStoreState.race);
    },

    [ADMIN_SELECT_DATABASE_SUCCESS] : (state, {championshipNo, ringNo}) => {
        return Object.assign({}, initialStoreState.race);
    }
});


// WEBPACK FOOTER //
// ./src/client/src/reducers/race.js